import { usePrevious } from '@react-hookz/web';
import { useEffect } from 'react';
import isEqual from 'react-fast-compare';
import { useGetUserContext } from '../../../../../hooks/useGetUserContext';
import { useGetGlobalAppStateStoreState } from '../../../../../stores/app/GlobalAppStateStore';
import { useSetDeviceContext } from '../helperHooks/useSetDeviceContext';
import { useSetUserDetailsAndContext } from '../helperHooks/useSetUserDetailsAndContext';

//locale is passed for preview in which user locale is different but
// we need to pick from cookie
function useSetUserInStore({ locale }: { locale?: string }) {
  const { userContext, deviceContext } = useGetUserContext();
  const { getGlobalAppStateStoreState } = useGetGlobalAppStateStoreState();
  const { setUserDetailsAndContext } = useSetUserDetailsAndContext();
  const { setDeviceContext } = useSetDeviceContext();

  const roles = (userContext as { roles?: { id: string; name: string }[] } | undefined)?.roles;
  const prevRolesIds = usePrevious(userContext?.roleIds);
  const prevRoles = usePrevious(roles);

  useEffect(() => {
    const userContextInStore = getGlobalAppStateStoreState().userContext;

    if (
      userContext &&
      (userContext.id !== userContextInStore.id ||
        !isEqual(prevRolesIds, userContext.roleIds) ||
        !isEqual(prevRoles, roles))
    ) {
      const updatedUserContext = { ...userContext, ...(locale ? { locale } : {}) };
      setUserDetailsAndContext({ userContext: updatedUserContext });
      // the runtime env travels with user changes (e.g. in-app login refreshed the
      // UserStore env before the user id flipped)
      if (deviceContext) {
        setDeviceContext(deviceContext);
      }
    }
  }, [
    userContext,
    deviceContext,
    getGlobalAppStateStoreState,
    prevRolesIds,
    prevRoles,
    roles,
    locale,
    setUserDetailsAndContext,
    setDeviceContext,
  ]);
}

export default useSetUserInStore;
